import { httpGet } from './http.service';

export class CountryService {
    load() {
        return httpGet('/countries').then(response => response.data);
    }
}